<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Process Tab" />

    <!-- Page Contents -->
    <sui-page-contents>
      <sui-process-tab
        :tab-items="tabItems"
        :default-tab-index="defaultTabIndex"
        :set-current-tab-component="setCurrentTabComponent"
        @change-processtab-idx="tabSelected"
        :showCount="false"
      >
        <container :is="currentTabComponent" />
      </sui-process-tab>
    </sui-page-contents>
  </sui-page>
</template>

<script>
// 탭 컴포넌트
import t02 from './components/tab02.vue';
import t03 from './components/tab03.vue';

// 페이지 컴포넌트
const PGE_CMU_00001 = utils.getPageComponentById('comp_container');

export default {
  name: 'PGE_CMU_00001', // eslint-disable-line vue/name-property-casing
  components: {
    PGE_CMU_00001,
    t02,
    t03,
  },
  data() {
    return {
      // Tab
      defaultTabIndex: 0,
      tabItems: [
        {
          title: 'processtab1',
          count: '55',
          component: PGE_CMU_00001,
        },
        {
          title: 'processtab2',
          count: '0',
          component: t02,
        },
        {
          title: 'processtab3',
          count: '20',
          component: t03,
        },
      ],
      currentTabComponent: PGE_CMU_00001,
    };
  },
  methods: {
    setCurrentTabComponent(component) {
      console.log('processTab.setCurrentTabComponent() was called.');
      this.currentTabComponent = component;
    },
    tabSelected(item) {
      console.log('processTab.tabSelected() was called.');
      console.log(item);
    },
  },
};
</script>

<style scoped>
</style>
